import { useEffect, useMemo, useState } from 'react'
import Modal from '../../Common/Modal/Modal';
import { fetchDesignationDetails } from '../../../Redux/action/MasterSkillAction';
import { useDispatch, useSelector } from 'react-redux';
import { AddExperienceAction } from '../../../Redux/action/CandidateCertificationAction';
import { toast } from 'react-toastify';
import { CandidateProfile } from '../../../Redux/action/CandidateProfileAction';
import { CiEdit } from 'react-icons/ci';
import { MdDeleteOutline } from 'react-icons/md';
import axios from 'axios';
import ViewExperiance from './ViewExperiance';
import { FaEye } from 'react-icons/fa';

const Experience = () => {
    const { userResult } = useSelector((state) => state.Auth);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModelOpen] = useState(false);
    const [loader, setLoader] = useState(false);
    const AllDesignationList = useSelector((state) => state?.MasterTableDetails?.designation?.content);
    const dispatch = useDispatch();
    const candidateId = userResult?.userid;;
    const [viewExp, setViewExp] = useState(false);
    const experienceList = useSelector((state) => state?.Profile?.result?.workExperiences)
    const [experienceData, setExperienceData] = useState({
        companyName: "",
        role: "",
        startDate: "",
        endDate: "",
        isCurrentlyWorking: false,
    })
    const [viewExperiance, setViewExperiance] = useState({
        companyName: "",
        role: "",
        startDate: "",
        endDate: "",
        isCurrentlyWorking: false,
    })

    const [experienceId, setExperienceId] = useState(null);

    useEffect(() => {
        dispatch(fetchDesignationDetails())
        dispatch(CandidateProfile(candidateId));
    }, [])

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setExperienceData({
            companyName: "",
            role: "",
            startDate: "",
            endDate: "",
            isCurrentlyWorking: false,
        })
    };

    function handleAddExperienceClick() {
        setIsModalOpen(true);
        setExperienceData({
            companyName: "",
            role: "",
            startDate: "",
            endDate: "",
            isCurrentlyWorking: false,
        })
    };

    function getMonthDifference(startDate, endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);

        const yearsDiff = end.getFullYear() - start.getFullYear();
        const monthsDiff = end.getMonth() - start.getMonth();

        return yearsDiff * 12 + monthsDiff + 1;
    }

    function getTimeGapInMonthsOrYears(startDate, endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);

        const yearsDiff = end.getFullYear() - start.getFullYear();
        const monthsDiff = end.getMonth() - start.getMonth();

        // Total months difference
        let totalMonths = yearsDiff * 12 + monthsDiff + 1;

        // If less than 12 months, return in months
        if (totalMonths < 12) {
            return `${totalMonths} month${totalMonths !== 1 ? "s" : ""}`;
        }

        // Convert months to years but keep 1.1 - 1.11 format
        let years = Math.floor(totalMonths / 12);  // Get whole years
        let remainingMonths = totalMonths % 12;    // Get leftover months

        // If there are remaining months, show it in decimal (1.1 - 1.11 years)
        if (remainingMonths > 0) {
            return `${years}.${remainingMonths} years`;
        }

        return `${years} years`; // Exact year case (e.g., "2 years")
    }

    function handleEditClick(item) {
        setIsEditModelOpen(true)
        console.log("item....", item);
        setExperienceData({
            companyName: item?.companyName ?? "",
            role: item?.role ?? "",
            startDate: item?.startDate ?? "",
            endDate: item?.endDate ?? "",
            isCurrentlyWorking: item?.isCurrentlyWorking ?? "",
        });
        setExperienceId(item?.workExperienceId ?? null)
    }

    const handleCloseEditModel = () => {
        setIsEditModelOpen(false)
        setExperienceData({
            companyName: "",
            role: "",
            startDate: "",
            endDate: "",
            isCurrentlyWorking: false,
        })
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setExperienceData((prev) => (
            {
                ...prev,
                [name]: value
            }
        ))
    }

    useMemo(() => {
        if (experienceData.isCurrentlyWorking === true) {
            setExperienceData({ ...experienceData, endDate: null })
        }
    }, [experienceData.isCurrentlyWorking])

    const handleSubmit = (e) => {
        e.preventDefault();
        const data = {
            candidateId: candidateId,
            ...experienceData
        }
        setLoader(true);
        try {
            dispatch(AddExperienceAction(data)).then((res) => {
                console.log("rsrsss ", res);
                if (res?.data) {
                    setExperienceData({
                        companyName: "",
                        role: "",
                        startDate: "",
                        endDate: "",
                        isCurrentlyWorking: false,
                    })
                    setTimeout(() => {
                        toast.success("Experience Added Successfully")
                        handleCloseModal()
                        dispatch(CandidateProfile(candidateId));
                    }, 2000)
                }
            }).finally(() => {
                setTimeout(() => {
                    setLoader(false);
                }, 1000)
            })
        } catch (error) {
            console.log("errr in adding experience", error);
        } finally {
            setTimeout(() => {
                setLoader(false)
            }, 1000)
        }
    }

    const handleUpdateWorkExperience = async (e) => {
        e.preventDefault()

        const data = {
            ...experienceData,
            "workExperienceId": experienceId,
        }
        setLoader(true)
        try {
            const result = await axios.put(`${process.env.REACT_APP_API_PATH}/ebench/update_work_experience`, data);
            const res = await result.data;
            if (res?.data) {
                setTimeout(() => {
                    toast.success("Experience Updates Sucessfully")
                    dispatch(CandidateProfile(candidateId));
                }, 1500)
                handleCloseEditModel();
                setExperienceId(null)
            } else {
                console.log("rss", res)
            }
        } catch (error) {
            console.log("object of update expriance", error)
            toast.error(error?.response?.data?.status?.message ?? "Internal Server Error")
        } finally {
            setLoader(false)
        }
    }

    const handleDeleteExperience = async (id) => {
        try {
            const result = await axios.delete(`${process.env.REACT_APP_API_PATH}/ebench/delete_work_experience?workExperienceId=${id}`);
            const data = result?.data;
            if (data?.data) {
                setTimeout(() => {
                    toast.success(data?.data?.body ?? "Work Experience Deleted Successfullys")
                    dispatch(CandidateProfile(candidateId));
                }, 100)
            }
            // console.log("dddd",data);
        } catch (err) {
            setTimeout(() => {
                toast.error(err?.message ?? "Internal Server Error")
            }, 1000)
            console.log("err", err);
        }
    }
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    console.log("gfsofsdfuufsi", formattedDate);
    return (
        <div>
            {!viewExp && <div>
                <div className="card can_prof_main">
                    <div className="card can_prof_main">
                        <div className="card-header common_table_header">
                            Experience
                        </div>
                        <div className="card-body table-responsive">
                            {experienceList && <table className="table-data" style={{ fontSize: '14px', width: '100%', textAlign: 'center' }}>
                                <thead>
                                    <tr style={{ textAlign: "center" }}>
                                        <th className="fw_500" scope="col">
                                            S.No
                                        </th>
                                        <th className="fw_500" scope="col">
                                            Company Name
                                        </th>
                                        <th className="fw_500" scope="col">
                                            Role
                                        </th>
                                        <th className="fw_500" scope="col">
                                            Duration
                                        </th>
                                        <th className="fw_500" scope="col">
                                            LWD
                                        </th>
                                        <th className="fw_500" scope="col">
                                            View
                                        </th>
                                        <th className="fw_500" scope="col">
                                            Actions
                                        </th>
                                        {/* <th className="fw_600" scope="col" colSpan={2}>Actions</th> */}
                                    </tr>
                                </thead>
                                <tbody
                                    className="skill_table_body"
                                    style={{ textAlign: "center" }}
                                >
                                    {experienceList &&
                                        experienceList?.map((item, index) => (
                                            <tr key={index}>
                                                <td scope="row">{index + 1}</td>
                                                <>
                                                    <td>
                                                        {item?.companyName || 'N/A'}
                                                    </td>
                                                    <td> {item?.role || 'N/A'}</td>
                                                    {/* <td>{item?.startDate || 'N/A'}</td> */}

                                                    {/* <td>{getMonthDifference(item?.startDate, item?.endDate) + " months" || 'N/A'}</td> */}
                                                    <td>{getTimeGapInMonthsOrYears(item?.startDate, item?.endDate ? item.endDate : formattedDate) || 'N/A'}</td>
                                                    <td> {item?.isCurrentlyWorking ? "Present" : item.endDate || 'N/A'}</td>
                                                </>
                                                <td style={{ cursor: 'pointer' }} onClick={() => {
                                                    setViewExp(true)
                                                    setViewExperiance({
                                                        companyName: item.companyName,
                                                        role: item.role,
                                                        startDate: item.startDate,
                                                        endDate: item.endDate,
                                                        workExperienceId: item.workExperienceId,
                                                        isCurrentlyWorking: item.isCurrentlyWorking,
                                                    });
                                                }}><FaEye size={25} color="#286a94" className="" /></td>
                                                {/* <td>
                                                {item.certificateImageUrl ? <a href={item.certificateImageUrl} target='_blank' rel="noreferrer" ></a> : 'N/A'}
                                            </td> */}
                                                <td colSpan={2}>
                                                    <div style={{ display: 'flex' }}>
                                                        <CiEdit size={25} color="#286a94" className="pointer me-2" onClick={() => {
                                                            handleEditClick(item)
                                                            // setCertificateData({
                                                            //     candidateId: item.candidateId,
                                                            //     courseName: item.courseName,
                                                            //     duration: durationNumeric, // Set numeric value of duration
                                                            //     durationUnit: durationUnit, // Set duration unit
                                                            //     certificationId: item.certificationId,
                                                            //     certificationUrl: item.certificationUrl,
                                                            //     year: item.year,
                                                            //     courseProvider: item.courseProvider
                                                            // });
                                                            // setSelectedImage(item.certificateImageUrl);
                                                            // setCertificateId(item.certificateId);
                                                            // setIsEditModalOpen(true);
                                                        }}
                                                        />
                                                        <MdDeleteOutline size={25} color="red" className="pointer" onClick={() => handleDeleteExperience(item?.workExperienceId)} />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>}
                            {experienceList.length === 0 && (
                                <h5 style={{ textAlign: "center", fontSize: '16px' }}>No data available</h5>
                            )}
                        </div>
                    </div>
                </div>
                <div className='d-flex justify-content-left ' style={{ boxShadow: 'none' }}>
                    <p className=' mt-5 pointer common_btn_outline2' style={{ background: '#286a94' }} onClick={handleAddExperienceClick}>
                        Add Experience
                    </p>
                </div>
            </div>}

            {viewExp &&
                <ViewExperiance viewExp={viewExp} setViewExp={setViewExp} data={viewExperiance} />
            }
            {
                isModalOpen &&
                <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
                    <p style={{ padding: "0px" }} className="common_table_header"> Add Experience </p>
                    <hr />
                    <form onSubmit={handleSubmit} className="card-body">
                            <div className="row  mb-3">
                                <div className="col-sm-6">
                                <label className="small mb-1">
                                    Company Name
                                    <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder='Company Name'
                                    name="companyName"
                                    value={experienceData.companyName}
                                    onChange={handleInputChange}
                                    required
                                        minLength="2"
                                        maxLength="250"
                                />
                            </div>
                                <div className="col-sm-6">
                                <label className="small mb-1">
                                    Role
                                    <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                </label>
                                <select id="inputOrgName" required value={experienceData.role} name="role" onChange={handleInputChange} className='form-select'>
                                    <option value="" disabled hidden>
                                        Select any designation

                                    </option>
                                    {AllDesignationList?.map((option) => (
                                        <option key={option?.designationId} value={option?.designation}>
                                            {option.designation}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="row gx-3 mb-3">
                                <div className='col-sm-6'>
                                <label className="small mb-1" >
                                    Start Date
                                    <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                </label>
                                <input
                                    type="date"
                                    className="form-control"
                                    placeholder='Start Name'
                                    name="startDate"
                                    value={experienceData.startDate}
                                    onChange={handleInputChange}
                                    required
                                        max={new Date().toISOString().split('T')[0]}
                                />
                            </div>
                                <div className='col-sm-6'>
                                <label className="small mb-1" >
                                    End Date
                                </label>
                                <input
                                    type="date"
                                    className="form-control"
                                    placeholder='End Name'
                                    name="endDate"
                                    value={experienceData.endDate}
                                    onChange={handleInputChange}
                                    min={experienceData?.startDate ?? ''}
                                    disabled={experienceData.isCurrentlyWorking}
                                    required
                                        max={new Date().toISOString().split('T')[0]}
                                />
                            </div>
                                <div className='col-sm-12'>
                                <input
                                    className="form-check-input me-2"
                                    type="checkbox"
                                    name='isCurrentlyWorking'
                                    checked={experienceData.isCurrentlyWorking}
                                    onChange={(e) => {
                                        const { name, type, checked, value } = e.target;
                                        setExperienceData(prev => ({
                                            ...prev,
                                            [name]: type === 'checkbox' ? checked : value
                                        }));
                                    }}
                                />
                                <label class="form-check-label" for="flexCheckDefault">
                                    Currently Working Here
                                </label>
                            </div>
                        </div>
                            <button type="submit" disabled={loader} style={{ background: '#286a94' }} className="btn-primary common_btn"> {loader ? 'Adding' : 'Add'} </button>
                    </form>
                </Modal>
            }
            {/* update certificate model  */}
            {
                isEditModalOpen &&
                <Modal isOpen={isEditModalOpen} onClose={handleCloseEditModel}>
                    <p style={{ padding: "0px" }} className="common_table_header"> Edit Experience </p>
                    <hr />
                    <form onSubmit={handleUpdateWorkExperience} className="card-body">
                            <div className="row  mb-3">
                                <div className="col-sm-6">
                                <label className="small mb-1">
                                    Company Name
                                    <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder='Company Name'
                                    name="companyName"
                                    value={experienceData?.companyName}
                                    onChange={handleInputChange}
                                    required
                                        minLength="2"
                                        maxLength="250"
                                />
                            </div>
                                <div className="col-sm-6">
                                <label className="small mb-1">
                                    Role
                                    <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                </label>

                                <select id="inputOrgName" required value={experienceData.role} name="role" onChange={handleInputChange} className='form-select'>
                                    <option value="" disabled hidden>
                                        Select any designation

                                    </option>
                                    {AllDesignationList?.map((option) => (
                                        <option key={option?.designationId} value={option?.designation}>
                                            {option.designation}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="row gx-3 mb-3">
                                <div className='col-sm-6'>
                                <label className="small mb-1" >
                                    Start Date
                                    <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                </label>
                                <input
                                    type="date"
                                    className="form-control"
                                    placeholder='Start Name'
                                    name="startDate"
                                    value={experienceData.startDate}
                                    onChange={handleInputChange}
                                    required
                                        max={new Date().toISOString().split('T')[0]}
                                />
                            </div>
                                <div className='col-sm-6'>
                                <label className="small mb-1" >
                                    End Date
                                    <span style={{ color: 'red', paddingLeft: 4 }} className="text-red-700 pl-[2px]">*</span>
                                </label>
                                <input
                                    type="date"
                                    className="form-control"
                                    placeholder='End Name'
                                    name="endDate"
                                    value={experienceData.endDate}
                                    min={experienceData?.startDate ?? ''}
                                    onChange={handleInputChange}
                                    required
                                    disabled={experienceData.isCurrentlyWorking}
                                        max={new Date().toISOString().split('T')[0]}
                                />
                            </div>
                                <div className='col-sm-12'>
                                <input
                                    className="form-check-input me-2"
                                    type="checkbox"
                                    name='isCurrentlyWorking'
                                    checked={experienceData.isCurrentlyWorking}
                                    onChange={(e) => {
                                        const { name, type, checked, value } = e.target;
                                        setExperienceData(prev => ({
                                            ...prev,
                                            [name]: type === 'checkbox' ? checked : value
                                        }));
                                    }}
                                />
                                <label class="form-check-label" for="flexCheckDefault">
                                    Currently Working Here
                                </label>
                            </div>
                        </div>
                            <button type="submit" disabled={loader} style={{ background: '#286a94' }} className="btn-primary common_btn">
                            {loader ? 'Loading...' : 'Save'}
                        </button>

                    </form>
                </Modal>
            }
        </div >
    )
}

export default Experience